// @ts-nocheck
/* eslint-disable */
export const appReports24Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.28137 2H18.0879C18.6402 2 19.0879 2.44772 19.0879 3V20.2778C19.0879 20.8301 18.6402 21.2778 18.0879 21.2778H5.00093C4.44865 21.2778 4.00093 20.8301 4.00093 20.2778V7.28043L9.28137 2ZM8.949 7.44807C9.22515 7.44807 9.449 7.22421 9.449 6.94807V3.0058L5.00673 7.44807H8.949Z" fill="currentColor"/></svg>`,
    name: 'reports-24' as const
};